"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProportionList = void 0;
var ProportionList_1 = require("./ProportionList");
Object.defineProperty(exports, "ProportionList", { enumerable: true, get: function () { return ProportionList_1.ProportionList; } });
